// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UzbekTransliterationApiRouteImport } from './routes/uzbek-transliteration-api'
import { Route as SubscriptionRouteImport } from './routes/subscription'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as RedirectRouteImport } from './routes/redirect'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as EmailVerifiedRouteImport } from './routes/email-verified'
import { Route as DonateRouteImport } from './routes/donate'
import { Route as DeferredRouteImport } from './routes/deferred'
import { Route as ComponentsRouteImport } from './routes/components'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as BalanceRouteImport } from './routes/balance'
import { Route as AboutRouteImport } from './routes/about'
import { Route as PathlessLayoutRouteImport } from './routes/_pathlessLayout'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as UsersRouteRouteImport } from './routes/users.route'
import { Route as PostsRouteRouteImport } from './routes/posts.route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShareShareCodeRouteImport } from './routes/share.$shareCode'
import { Route as PathlessLayoutNestedLayoutRouteImport } from './routes/_pathlessLayout/_nested-layout'
import { Route as LangIndexRouteImport } from './routes/$lang.index'
import { Route as LangVerifyEmailRouteImport } from './routes/$lang.verify-email'
import { Route as LangUzbekTransliterationApiRouteImport } from './routes/$lang.uzbek-transliteration-api'
import { Route as LangSubscriptionRouteImport } from './routes/$lang.subscription'
import { Route as LangResetPasswordRouteImport } from './routes/$lang.reset-password'
import { Route as LangRegisterRouteImport } from './routes/$lang.register'
import { Route as LangProfileRouteImport } from './routes/$lang.profile'
import { Route as LangLoginRouteImport } from './routes/$lang.login'
import { Route as LangForgotPasswordRouteImport } from './routes/$lang.forgot-password'
import { Route as LangFaqRouteImport } from './routes/$lang.faq'
import { Route as LangEmailVerifiedRouteImport } from './routes/$lang.email-verified'
import { Route as LangDonateRouteImport } from './routes/$lang.donate'
import { Route as LangChatRouteImport } from './routes/$lang.chat'
import { Route as LangBalanceRouteImport } from './routes/$lang.balance'
import { Route as LangAboutRouteImport } from './routes/$lang.about'
import { Route as UsersIndexRouteImport } from './routes/users.index'
import { Route as UsersUserIdRouteImport } from './routes/users.$userId'
import { Route as PostsIndexRouteImport } from './routes/posts.index'
import { Route as PostsPostIdRouteImport } from './routes/posts.$postId'
import { Route as PostsPostIdDeepRouteImport } from './routes/posts_.$postId.deep'
import { Route as AuthTelegramCallbackRouteImport } from './routes/auth.telegram.callback'
import { Route as PathlessLayoutNestedLayoutRouteBRouteImport } from './routes/_pathlessLayout/_nested-layout/route-b'
import { Route as PathlessLayoutNestedLayoutRouteARouteImport } from './routes/_pathlessLayout/_nested-layout/route-a'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const UzbekTransliterationApiRoute = UzbekTransliterationApiRouteImport.update({
            id: '/uzbek-transliteration-api',path: '/uzbek-transliteration-api',getParentRoute: () => rootRouteImport
          })
const SubscriptionRoute = SubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const RedirectRoute = RedirectRouteImport.update({
            id: '/redirect',path: '/redirect',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const EmailVerifiedRoute = EmailVerifiedRouteImport.update({
            id: '/email-verified',path: '/email-verified',getParentRoute: () => rootRouteImport
          })
const DonateRoute = DonateRouteImport.update({
            id: '/donate',path: '/donate',getParentRoute: () => rootRouteImport
          })
const DeferredRoute = DeferredRouteImport.update({
            id: '/deferred',path: '/deferred',getParentRoute: () => rootRouteImport
          })
const ComponentsRoute = ComponentsRouteImport.update({
            id: '/components',path: '/components',getParentRoute: () => rootRouteImport
          })
const ChatRoute = ChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => rootRouteImport
          })
const BalanceRoute = BalanceRouteImport.update({
            id: '/balance',path: '/balance',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const PathlessLayoutRoute = PathlessLayoutRouteImport.update({
            id: '/_pathlessLayout',getParentRoute: () => rootRouteImport
          })
const LangRoute = LangRouteImport.update({
            id: '/$lang',path: '/$lang',getParentRoute: () => rootRouteImport
          })
const UsersRouteRoute = UsersRouteRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => rootRouteImport
          })
const PostsRouteRoute = PostsRouteRouteImport.update({
            id: '/posts',path: '/posts',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ShareShareCodeRoute = ShareShareCodeRouteImport.update({
            id: '/share/$shareCode',path: '/share/$shareCode',getParentRoute: () => rootRouteImport
          })
const PathlessLayoutNestedLayoutRoute = PathlessLayoutNestedLayoutRouteImport.update({
            id: '/_nested-layout',getParentRoute: () => PathlessLayoutRoute
          })
const LangIndexRoute = LangIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangRoute
          })
const LangVerifyEmailRoute = LangVerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => LangRoute
          })
const LangUzbekTransliterationApiRoute = LangUzbekTransliterationApiRouteImport.update({
            id: '/uzbek-transliteration-api',path: '/uzbek-transliteration-api',getParentRoute: () => LangRoute
          })
const LangSubscriptionRoute = LangSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => LangRoute
          })
const LangResetPasswordRoute = LangResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => LangRoute
          })
const LangRegisterRoute = LangRegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => LangRoute
          })
const LangProfileRoute = LangProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => LangRoute
          })
const LangLoginRoute = LangLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => LangRoute
          })
const LangForgotPasswordRoute = LangForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => LangRoute
          })
const LangFaqRoute = LangFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => LangRoute
          })
const LangEmailVerifiedRoute = LangEmailVerifiedRouteImport.update({
            id: '/email-verified',path: '/email-verified',getParentRoute: () => LangRoute
          })
const LangDonateRoute = LangDonateRouteImport.update({
            id: '/donate',path: '/donate',getParentRoute: () => LangRoute
          })
const LangChatRoute = LangChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => LangRoute
          })
const LangBalanceRoute = LangBalanceRouteImport.update({
            id: '/balance',path: '/balance',getParentRoute: () => LangRoute
          })
const LangAboutRoute = LangAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LangRoute
          })
const UsersIndexRoute = UsersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UsersRouteRoute
          })
const UsersUserIdRoute = UsersUserIdRouteImport.update({
            id: '/$userId',path: '/$userId',getParentRoute: () => UsersRouteRoute
          })
const PostsIndexRoute = PostsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PostsRouteRoute
          })
const PostsPostIdRoute = PostsPostIdRouteImport.update({
            id: '/$postId',path: '/$postId',getParentRoute: () => PostsRouteRoute
          })
const PostsPostIdDeepRoute = PostsPostIdDeepRouteImport.update({
            id: '/posts_/$postId/deep',path: '/posts/$postId/deep',getParentRoute: () => rootRouteImport
          })
const AuthTelegramCallbackRoute = AuthTelegramCallbackRouteImport.update({
            id: '/auth/telegram/callback',path: '/auth/telegram/callback',getParentRoute: () => rootRouteImport
          })
const PathlessLayoutNestedLayoutRouteBRoute = PathlessLayoutNestedLayoutRouteBRouteImport.update({
            id: '/route-b',path: '/route-b',getParentRoute: () => PathlessLayoutNestedLayoutRoute
          })
const PathlessLayoutNestedLayoutRouteARoute = PathlessLayoutNestedLayoutRouteARouteImport.update({
            id: '/route-a',path: '/route-a',getParentRoute: () => PathlessLayoutNestedLayoutRoute
          })





const PostsRouteRouteChildren = {
  PostsPostIdRoute: PostsPostIdRoute,PostsIndexRoute: PostsIndexRoute
}

const PostsRouteRouteWithChildren = PostsRouteRoute._addFileChildren(PostsRouteRouteChildren)




const UsersRouteRouteChildren = {
  UsersUserIdRoute: UsersUserIdRoute,UsersIndexRoute: UsersIndexRoute
}

const UsersRouteRouteWithChildren = UsersRouteRoute._addFileChildren(UsersRouteRouteChildren)




const LangRouteChildren = {
  LangAboutRoute: LangAboutRoute,LangBalanceRoute: LangBalanceRoute,LangChatRoute: LangChatRoute,LangDonateRoute: LangDonateRoute,LangEmailVerifiedRoute: LangEmailVerifiedRoute,LangFaqRoute: LangFaqRoute,LangForgotPasswordRoute: LangForgotPasswordRoute,LangLoginRoute: LangLoginRoute,LangProfileRoute: LangProfileRoute,LangRegisterRoute: LangRegisterRoute,LangResetPasswordRoute: LangResetPasswordRoute,LangSubscriptionRoute: LangSubscriptionRoute,LangUzbekTransliterationApiRoute: LangUzbekTransliterationApiRoute,LangVerifyEmailRoute: LangVerifyEmailRoute,LangIndexRoute: LangIndexRoute
}

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren)




const PathlessLayoutNestedLayoutRouteChildren = {
  PathlessLayoutNestedLayoutRouteARoute: PathlessLayoutNestedLayoutRouteARoute,PathlessLayoutNestedLayoutRouteBRoute: PathlessLayoutNestedLayoutRouteBRoute
}

const PathlessLayoutNestedLayoutRouteWithChildren = PathlessLayoutNestedLayoutRoute._addFileChildren(PathlessLayoutNestedLayoutRouteChildren)



const PathlessLayoutRouteChildren = {
  PathlessLayoutNestedLayoutRoute: PathlessLayoutNestedLayoutRouteWithChildren
}

const PathlessLayoutRouteWithChildren = PathlessLayoutRoute._addFileChildren(PathlessLayoutRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,PostsRouteRoute: PostsRouteRouteWithChildren,UsersRouteRoute: UsersRouteRouteWithChildren,LangRoute: LangRouteWithChildren,PathlessLayoutRoute: PathlessLayoutRouteWithChildren,AboutRoute: AboutRoute,BalanceRoute: BalanceRoute,ChatRoute: ChatRoute,ComponentsRoute: ComponentsRoute,DeferredRoute: DeferredRoute,DonateRoute: DonateRoute,EmailVerifiedRoute: EmailVerifiedRoute,FaqRoute: FaqRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,ProfileRoute: ProfileRoute,RedirectRoute: RedirectRoute,RegisterRoute: RegisterRoute,ResetPasswordRoute: ResetPasswordRoute,SubscriptionRoute: SubscriptionRoute,UzbekTransliterationApiRoute: UzbekTransliterationApiRoute,VerifyEmailRoute: VerifyEmailRoute,ShareShareCodeRoute: ShareShareCodeRoute,AuthTelegramCallbackRoute: AuthTelegramCallbackRoute,PostsPostIdDeepRoute: PostsPostIdDeepRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)